import { useGridApiContext } from '@mui/x-data-grid-premium';
import { DynamicFormBuilderContainer } from '../formBuilder/dynamicFormBuilder.container';
export default function ExpandedRowDetails(props) {
    var _a;
    var elements = props.elements, row = props.row, id = props.id, updateRow = props.updateRow, errors = props.errors, disabled = props.disabled;
    var api = useGridApiContext();
    var res = {
        data: row,
        success: true
    };
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer
    // getFormAPI={async () => res}
    , {
        mode: disabled ? 'view' : 'edit',
        formData: elements
        // updateFormAPI={async ({ request }) => {
        //     updateRow(request)
        //     return { success: true }
        // }}
        ,
        onClose: function () {
            api.current.toggleDetailPanel(id);
        },
        errors: errors && (_a = {
                id: errors.id
            },
            _a[errors.field] = errors.message,
            _a),
        onChange: function (e, _ref) {
            var state = _ref.state;
            updateRow(e, state);
        },
        gridSpacing: 0,
        state: row
    });
}
